function removeFont16pxFromStyle(text) {
  return text ? text.replace(/font-size:\s*16px;/g, "") : text;
}

export { removeFont16pxFromStyle };
